import {IConcept} from 'app/models/concept'
import {CGraphEntity} from './graph_entity'
import {CNote} from './note'
import {JsonObject} from 'utilities/types'

export class CConcept extends CGraphEntity<IConcept> implements IConcept {
  static children = {
    notes: CNote,
  }

  aliases
  qid
  score
  related_concepts?: any[] | undefined
  businesses?: any[] | undefined

  constructor(data: IConcept & JsonObject) {
    super('Concept', data)
    this.aliases = data.aliases ?? []
    this.qid = data.qid ?? ''
    this.score = data.score ?? 0
    this.related_concepts = data.related_concepts
    this.businesses = data.businesses
  }

  stringify() {
    return JSON.stringify(this.export())
  }

  export() {
    return {id: this.id}
  }
}
